import { useCallback } from 'react';
import { type TextElement } from '@bynder-studio/render-core';
import { type AlignmentNumber } from 'packages/pages/editor/RightSideMenu/Shots/Text/TextAlignment/utils';
import useElement from './useElement';

export function useTextElementAlignment(elementId: number) {
    const { element, updateElement } = useElement(elementId);

    const { horizontalAlignment } = (element as TextElement).contentTransform;

    const changeHorizontalAlignment = useCallback(
        (horizontalAlignment: AlignmentNumber) => {
            updateElement({
                contentTransform: {
                    ...(element as TextElement).contentTransform,
                    horizontalAlignment,
                },
            });
        },
        [updateElement, element],
    );

    return {
        horizontalAlignment,
        changeHorizontalAlignment,
    };
}
